import { render } from "./Affiliates.vue?vue&type=template&id=5e4e839a&scoped=true"
import script from "./Affiliates.vue?vue&type=script&lang=js"
export * from "./Affiliates.vue?vue&type=script&lang=js"

import "./Affiliates.vue?vue&type=style&index=0&id=5e4e839a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4e839a"]])

export default __exports__